<template>
  <img
    :src="handleImgSize(src,'list')"
    :style="{borderRadius:radius,width:width,height:height}"
    v-if="src"
    alt="">
</template>

<script>
  export default {
    name: 'imageComp',
    mixins: [],
    props: {
      src: {
        type: String,
        default: ''
      },
      szie: {
        type: String,
        default: 'list'
      },
      width: {
        type: String,
        default: 'auto'
      },
      height: {
        type: String,
        default: 'auto'
      },
      radius: {
        type: String,
        default: '0px'
      }
    },
    model: {},
    components: {},
    data () {
      return {
      };
    },
    computed: {},
    methods: {},
    watch: {},
    created () {
    },
    mounted () {
    },
    updated () {
    },
    beforeDestroy () {
    },
    destroyed () {
    }
  };
</script>

<style scoped lang="less">
img{
  width: auto;
  height: auto;
}
</style>
